import { gql, useQuery } from '@apollo/client'
import { NavigationQuery, NavigationQueryVariables } from 'types/graphql'
import { usePathParam } from 'utils/usePathParam'

export const getNavigationQuery = gql`
  query Navigation($username: String!) {
    user(username: $username) {
      id
      reviewCount
      listCount
    }
  }
`

export const useNavigation = () => {
  const username = usePathParam('username')

  if (!username) {
    throw new Error('The required param "username" is missing from path.')
  }

  return useQuery<NavigationQuery, NavigationQueryVariables>(getNavigationQuery, {
    variables: {
      username: username.toString()
    }
  })
}
